// extracted by mini-css-extract-plugin
export default {"container":"Carousel_container__wsUu9","arrowContainer":"Carousel_arrowContainer__NHxWp","slide":"Carousel_slide__o48Io"};